import { Column, Grid } from "@/components/layout/Grid";
import React from "react";
import { CardContainer } from "@/components/cards/CardElements";

interface LoadingStateProps {
  columns?: number;
  postCount?: number;
  classes?: string;
  card_classes?: string;
}

export function LoadingCards({
  classes,
  card_classes,
  columns = 5,
  postCount = 15,
}: LoadingStateProps) {
  return (
    <>
      <Grid
        columns={columns}
        classes={`min-h-[40vh] relative same-height-all-group animate-pulse ${classes}`}
      >
        {/* Columns */}
        {[...Array(postCount)].map((post, index) => (
          <Column key={`skeleton-${index}`} classes={"relative"}>
            <CardContainer classes={`card ${card_classes}`}>
              <div className="card-media overflow-hidden">
                <div className="media-link wide-ratio bg-[#F1F1F1]"></div>
              </div>

              <div className="card-body content gap-y-2 Cards_card-body__osci6">
                <p className={`h-3.5 rounded-3 w-full bg-[#F1F1F1]`}></p>
                <p className={`h-3.5 rounded-3 w-full bg-[#F1F1F1]`}></p>
                <p className={`h-3.5 rounded-3 w-full bg-[#F1F1F1]`}></p>
                <p className={`h-3.5 rounded-3 w-1/2 bg-[#F1F1F1]`}></p>
                <p className={`h-3.5 rounded-3 w-12 mt-2.5 bg-[#F1F1F1]`}></p>
              </div>
            </CardContainer>
          </Column>
        ))}
      </Grid>
    </>
  );
}
